export default __webpack_public_path__ + "static/media/anniversary-banner-id.63b201ad.webp";